import { useEffect, useRef, useState } from "react";
import { IoDownload, IoDuplicate   } from "react-icons/io5";
import { MdEdit } from "react-icons/md";
import { IoCopy } from "react-icons/io5";
import { BiSolidTrashAlt } from "react-icons/bi";
import { copyFolder, duplicateFolder, downloadFolder } from "../../../../api/businessAndEnterprise/driveApi";
import ReactNotifications from "../../../common/reactNotifications/ReactNotifications";
import * as utilConstants from "../../../../utils/constants/utilsConstants";
import DeleteModal from "../../../common/commonModal/DeleteModal";
import { HiDotsVertical } from "react-icons/hi";
import CopyModal from "./CopyModal";

const Menu = ({ item, fetchAllPersonalDrives, handleOpenModal, deleteApiFunc, type, isAddEdit = true }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const menuRef = useRef(null);
    const [showDelModal, setShowDelModal] = useState(false);
    const [delRow, setDelRow] = useState({});
    const [showCopyModal, setShowCopyModal] = useState(false);
    const [copyDestinationFolderId, setCopyDestinationFolderId] = useState(null);
    const [loading, setLoading] = useState(false);

    const toggleMenu = (e) => {
        e.stopPropagation();
        setMenuOpen((prev) => !prev);
    };

    const handleDownload = () => {
        if (item?.id) {
            downloadFolder(item.id, (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    setMenuOpen(false);
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleCopyClick = () => {
        setMenuOpen(false);
        setShowCopyModal(true);
    };

    const handleCopy = () => {
        if (item?.id && copyDestinationFolderId !== null) {
            copyFolder(item.id, { parent: copyDestinationFolderId }, (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    fetchAllPersonalDrives();
                    setShowCopyModal(false);
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleDuplicate = () => {
        if (item?.id) {
            duplicateFolder(item.id, (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    fetchAllPersonalDrives();
                    setMenuOpen(false);
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
            })
        }
    };

    const handleRename = () => {
        handleOpenModal('edit', item)
        setMenuOpen(false);
    };

    const handleDeleteClick = (row) => {
        setDelRow(row);
        setMenuOpen(false);
        setShowDelModal(true);
    };

    const handleDelete = () => {
        setLoading(true);
        if (delRow?.id) {
            deleteApiFunc(delRow.id, (res) => {
                if (res?.status === true) {
                    ReactNotifications(res?.message, utilConstants.sucessState200);
                    fetchAllPersonalDrives();
                    setShowDelModal(false);
                } else {
                    ReactNotifications(res?.data?.message, utilConstants.getErrorStatus);
                }
                setLoading(false);
            })
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="flex items-center text-gray-500 w-full justify-end font-bold relative" ref={menuRef}>
            <span
                className="cursor-pointer text-xl text-[#000000] bg-[#F6F6F6] p-1 rounded-full"
                onClick={toggleMenu}
            >
                <HiDotsVertical size={22} />
            </span>

            {menuOpen && (
                <div className="absolute right-4 bottom-8 bg-white border shadow-lg rounded-md z-10">
                    {type === 'folder' && (
                        <>
                            <button
                                onClick={handleDuplicate}
                                className="block w-full !text-left px-4 py-2 text-sm text-[#0A121A] hover:bg-gray-100 font-normal"
                            >
                                <span className="flex items-center justify-start gap-2"><IoDuplicate size={18} />Duplicate</span>
                            </button>
                            <button
                                onClick={handleDownload}
                                className="block w-full !text-left px-4 py-2 text-sm text-[#0A121A] hover:bg-gray-100 font-normal"
                            >
                                <span className="flex items-center justify-start gap-2"><IoDownload size={18} />Download</span>
                            </button>
                            <button
                                onClick={handleCopyClick}
                                className="block w-full !text-left px-4 py-2 text-sm text-[#0A121A] hover:bg-gray-100 font-normal"
                            >
                                <span className="flex items-center justify-start gap-2"><IoCopy size={18} />Copy</span>
                            </button>
                        </>
                    )}
                   { isAddEdit && ( <>
                    <button
                        onClick={handleRename}
                        className="block w-full !text-left px-4 py-2 text-sm text-[#0A121A] hover:bg-gray-100 font-normal"
                    >
                        <span className="flex items-center justify-start gap-2"><MdEdit size={18} />Rename</span>
                    </button>
                    <button
                        onClick={() => handleDeleteClick(item)}
                        className="block w-full !text-left px-4 py-2 text-sm hover:bg-gray-100 text-red-500 font-normal"
                    >
                        <span className="flex items-center justify-start gap-2"><BiSolidTrashAlt size={18} />Delete</span>
                    </button>
                    </> )}
                </div>
            )}

            <DeleteModal
                show={showDelModal}
                onClose={() => setShowDelModal(false)}
                isLoading={loading}
                onConfirm={handleDelete}
                title="Delete Folder"
                message={`Are you sure you want to delete this ${type === 'folder' ? 'folder' : 'sheet'}? This action cannot be undone.`}
            />
            <CopyModal
                show={showCopyModal}
                onClose={() => setShowCopyModal(false)}
                onConfirm={handleCopy}
                onSelectFolder={setCopyDestinationFolderId}
                currentFolderId={item?.id}
            />
        </div>
    );
};

export default Menu;